<template>
  <section class="section">
    <div class="container has-text-centered has-text-white">
      <h3 class="title">
        Tabulation Data Has Been Updated
      </h3>
      <div class="has-text-left">
        <p>
          Please refresh the page to continue.
        </p>
        <p class="mt-3">
          <a :href="refreshLink" class="button is-primary">Refresh</a>
          <a :href="restoreSessionLink" class="button is-primary ml-1">Restore Session</a>
        </p>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapState } from "pinia";
  import { useSelectionStore } from "App/stores/selection";

  export default {
    computed: {
      ...mapState(useSelectionStore, {
        serializedSession: 'serializedSession'
      }),

      refreshLink() {
        return "/";
      },

      restoreSessionLink() {
        const serializedSession = this.serializedSession;
        const l = window.location;
        return l.protocol + "//" + l.host + `/session?session=${serializedSession}`;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~App/styles/variables";

  .title {
    color: $white;
  }
</style>